import http,{ setToken } from './http';
import cache from './cache';

export default {
    install: function (Vue) {
        Vue.prototype.$api = http;
        Vue.prototype.$cache = cache;
    },
    setToken(token) {
        setToken(token);
    }
}